import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";

import { progressBarStyles } from "./wow-progress-bar.css";

@customElement("wow-progress-bar")
export class WowProgressBar extends LitElement {
  @property({ type: Number }) max = 100;
  @property({ type: Number }) current = 0;

  static override styles = progressBarStyles;

  override render() {
    return html`
      <progress
        class="progress-container"
        max="${this.max}"
        value="${Math.max(0, Math.min(this.current, this.max))}"
      ></progress>
    `;
  }
}
